import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=45669a96&scoped=true&"
import script from "./announcements.vue?vue&type=script&lang=js&"
export * from "./announcements.vue?vue&type=script&lang=js&"
import style0 from "./announcements.vue?vue&type=style&index=0&id=45669a96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../igi-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45669a96",
  null
  
)

export default component.exports